import React from 'react';

export interface PageHeaderProps {
  header: string;
  subHeader?: string;
  buttonText?: string;
  isButtonDisabled?: boolean;
  onButtonClick?: () => void;
  buttonLoading?: boolean;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  header,
  subHeader,
  buttonText,
  isButtonDisabled,
  onButtonClick,
  buttonLoading,
}) => {
  return (
    <div className="mb-6 flex items-center justify-between pb-4">
      <div className="space-y-2">
        <h1 className="font-open-sans text-3xl font-semibold leading-[60px] text-black">{header}</h1>
        {subHeader && (
          <p className="font-open-sans text-section-header-slate text-sm font-medium leading-6">{subHeader}</p>
        )}
      </div>
      {buttonText && (
        <button
          onClick={onButtonClick}
          disabled={isButtonDisabled || buttonLoading}
          className="text-primary font-open-sans bg-button-secondary hover:bg-button-secondary-hover inline-flex h-10 items-center justify-center gap-1.5 rounded-full px-6 py-2.5 text-base font-medium leading-5 transition-colors disabled:opacity-50"
        >
          {buttonLoading ? 'Saving...' : buttonText}
        </button>
      )}
    </div>
  );
};
